import _classCallCheck from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import Query from "./Query";

var QueryBuilder =
/*#__PURE__*/
function () {
  function QueryBuilder(baseQuery) {
    _classCallCheck(this, QueryBuilder);

    if (typeof baseQuery !== 'undefined') {
      this._queryString = baseQuery.queryString;
      this._geometry = baseQuery.geometry;
      this._limit = baseQuery.limit;
      this._type = baseQuery.type;
      this._target = {
        source: baseQuery.target.source,
        type: baseQuery.target.type
      };
    } else {
      this._queryString = "";
      this._geometry = null;
      this._limit = null;
      this._type = null;
      this._target = {
        source: null,
        type: null
      };
    }
  }

  _createClass(QueryBuilder, [{
    key: "build",
    value: function build() {
      var query = new Query();
      query.queryString = this._queryString;
      query.target = {
        source: this._target.source,
        type: this._target.type
      };
      query.geometry = this._geometry;
      query.limit = this._limit;
      query.type = this._type;
      return query;
    }
  }, {
    key: "queryString",
    value: function queryString(_queryString) {
      this._queryString = _queryString;
      return this;
    }
  }, {
    key: "geometry",
    value: function geometry(_geometry) {
      this._geometry = _geometry;
      return this;
    }
  }, {
    key: "limit",
    value: function limit(_limit) {
      this._limit = _limit;
      return this;
    }
  }, {
    key: "type",
    value: function type(_type) {
      this._type = _type;
      return this;
    }
  }, {
    key: "target",
    value: function target(_target) {
      this._target = {
        source: _target.source,
        type: _target.type
      };
      return this;
    }
  }]);

  return QueryBuilder;
}();

export { QueryBuilder as default };